module.exports = __webpack_public_path__ + "img/chevron-left-inapp.223ea935.svg";